<template>
    <div :class="$style['edit-css']">
        <div :class="$style['editProfile']">
            <div :class="$style['loginWapper']">
                <div>
                    <div :class="$style['fieldProfile']">
                        <label>نام و نام خانوادگی</label>
                        <v-text-field
                                dir="auto"
                                solo
                                hide-details
                                :value="fullName"
                                v-model="fullName"
                        ></v-text-field>
                    </div>
                    <div :class="$style['fieldProfile']">
                        <label>شماره موبایل(غیر قابل ویرایش)</label>
                        <v-text-field
                                dir="auto"
                                solo
                                hide-details
                                disabled
                                :value="phoneNumber"
                                v-model="phoneNumber"
                        ></v-text-field>
                    </div>
                    <div :class="$style['fieldProfile']">
                        <label>پست الکترونیک خود را وارد کنید</label>
                        <v-text-field
                                dir="auto"
                                solo
                                hide-details
                                :value="email"
                                v-model="email"
                        ></v-text-field>
                    </div>
                    <div :class="$style['fieldProfile']">
                        <label>تاریخ تولد خود را وارد کنید</label>
                        <div :class="$style['datepicker-parent']">
                            <date-picker
                                    :class="$style['datepicker']"
                                    v-model="birthday"
                                    hide-details
                            ></date-picker>
                        </div>
                    </div>
                    <div :class="$style['fieldProfile-btn']">
                        <label>جهت تحویل سفارش حضوری درب خودرو</label>
                        <v-btn block color="#7ec352" role="button" v-ripple @click="$router.push('/vehicles')">
                            <v-icon style="margin-left: 5px">airport_shuttle</v-icon>
                            خودرو های من
                        </v-btn>
                    </div>
                </div>
            </div>
            <div :class="$style['btn_registration']">
                <v-btn block color="#7ec352" large role="button" v-ripple @click="editProfile"
                >ثبت ویرایش
                </v-btn>
            </div>
        </div>

        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                timeout="6000">
            {{ text }}

            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" role="button" v-ripple @click="snackbar = false">
                    <v-icon>cancel</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
    import VuePersianDatetimePicker from "vue-persian-datetime-picker";
    import oracle from "@/utils/oracle";

    export default {
        name: "EditProfile",
        data() {
            return {
                dataProfile: "",
                email: "",
                allDataProfile: null,
                active_el: 0,
                active_gender: 0,
                rules: [(v) => v.length <= 25 || "Max 25 characters"],
                text: "",
                snackbar: false,
                array: [],
                fullName: "",
                birthday: "",
                phoneNumber: "",
                bio: "",
                gender: "",
                user_avatar: "",
            };
        },
        methods: {
            activate: function (el) {
                this.active_el = el;
            },
            activeGender: function (el) {
                this.active_gender = el;
            },
            getCurrentDay() {
                var date = new Date();
                return date.toString();
            },
            getProfile(res) {
                this.fullName = res.data.username;
                this.phoneNumber = res.data.phone;
                this.email = res.data.email;
                this.birthday = res.data.user_profile != null ? res.data.user_profile.birth_date : null;

            },
            editProfile() {
                const data = {
                    "phone": this.phoneNumber,
                    "user_profile": {
                        "birth_date": this.birthday
                    },
                    "email": this.email,
                    "username": this.fullName,
                };
                oracle.axios("user/edit", data, this.setProfile);
            },
            setProfile(res) {
                this.snackbar = true
                this.text = res.message;
                oracle.axios("user/getProfile", null, this.getProfile);
            },
        },

        mounted() {
            oracle.axios("user/getProfile", null, this.getProfile);
        },

        components: {
            datePicker: VuePersianDatetimePicker,
        },
    };
</script>
<style module>
    /*.edit-css  .editProfile {*/
    /*    margin-top: -80px;*/
    /*}*/

    .edit-css .headerTop-basket {
        background: #4b4a4a;
        padding: 15px 10px;
        display: flex;
        /*border-bottom: 4px solid #ffea6b;*/
    }

    .edit-css .headerProfile {
        background-color: #7ec352;
        position: relative;
        left: 0;
        top: -2;
        width: 100%;
        height: 250px;
        padding: 18px;
        display: flex;
        justify-content: flex-end;
        margin-top: -60px;
    }

    .edit-css .headerProfile img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
        z-index: 1;
        opacity: 0.2;
    }

    .edit-css .loginWapper {
        padding: 0px 20px;
        /*padding-top: 130px;*/
        height: 100%;
        /*margin-top: -70px;*/
    }

    .edit-css .loginBox {
        width: 100%;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 3px 6px #00000029;
        z-index: 10;
        position: relative;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        top: -95px;
    }

    .edit-css .loginAvatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 3px 6px #00000029;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 4px solid #f9dc63;
    }

    .edit-css .loginAvatar img {
        width: 100%;
        height: 100%;
    }

    .edit-css .fieldProfile,
    .edit-css .fieldArea {
        margin: 0 15px;
        color: #000;
    }

    .edit-css .fieldProfile-btn {
        margin: 50px 15px;
        display: flex;
        flex-direction: column;
    }

    .edit-css .fieldProfile-btn label {
        margin-bottom: 5px !important;
    }

    .edit-css .fieldProfile-btn button {
        color: white !important;
    }

    .edit-css .fieldProfile label,
    .edit-css .fieldState label,
    .edit-css .fieldCity label {
        color: #a1a1a1;
        font-size: 12px;
        display: flex;
        justify-content: flex-start;
        margin: 15px 0 !important;
    }

    .edit-css .datepicker {
        margin-top: auto;
        margin-bottom: auto;
        width: 100%;
    }

    .edit-css .datepicker-parent {
        display: flex;
        font-size: 20px;
        height: 50px;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
    }

    .edit-css .datepicker label {
        display: none;
    }

    .edit-css .datepicker input {
        border: none;
    }

    .edit-css .v-input__slot,
    .edit-css .vpd-input-group {
        border: 1px solid #707070 !important;
        box-shadow: none !important;
        border-radius: 4px;
    }

    .edit-css .vpd-input-group,
    .edit-css .v-input--radio-group__input {
        flex: 1 1 auto;
        line-height: 20px;
        padding: 8px 0;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        justify-content: center;
        display: flex;
    }

    .edit-css .v-input--radio-group__input {
        justify-content: flex-start;
    }

    .edit-css .v-application .primary--text {
        color: #7ec352 !important;
        caret-color: #7ec352 !important;
    }

    .edit-css .fieldArea {
        display: flex;
        padding-top: 10px;
        color: #a1a1a1 !important;
    }

    .edit-css .fieldState {
        margin-left: 10px;
    }

    .edit-css .fieldState, .fieldCity {
        width: 50%;
    }

    .edit-css .fieldState label,
    .edit-css .fieldCity label {
        display: flex;
        justify-content: flex-start;
    }

    .edit-css .fieldState .v-text-field label,
    .edit-css .fieldCity .v-text-field label {
        color: #000;
        font-size: 13px;
    }

    .edit-css .btn_registration {
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .edit-css .btn_registration button {
        height: 60px !important;
        border-radius: 0;
        font-size: 15px;
        color: #fff !important;
    }

    .edit-css .v-btn {
        border-radius: 0;
    }

    .edit-css #uploaduser {
        width: 0;
        height: 0;
        opacity: 0;
    }

    .edit-css .profileAvatar {
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        position: relative;
        margin: 0 auto;
        margin-top: -60px;
        margin-bottom: 1.5em;
    }

    .edit-css .uploadAvatar {
        position: absolute;
        right: 5px;
        bottom: 5px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25px;
        background: #fff;
    }

    .edit-css .uploadAvatar .v-icon {
        font-size: 17px !important;
        color: #7ec352 !important;
    }

    .edit-css .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .edit-css .titleloginAvatar {
        display: flex;
        justify-content: center;
        color: #707070;
        margin-bottom: 10px;
        letter-spacing: inherit;
    }

    .edit-css .titleloginAvatar span {
        letter-spacing: inherit;
        font-size: 14px;
    }

    .edit-css .fieldProfile .v-textarea textarea {
        padding: 5px 10px;
    }

</style>
